import { Container } from '@mui/material';
import OauthLoginForm from 'components/form/OauthLoginForm';
import { useSearchParams } from 'react-router-dom';

export default function Oauth() {
  const [searchParams] = useSearchParams();
  const resultToken = searchParams.get('resultToken');

  return (
    <Container>
      <OauthLoginForm resultToken={resultToken!}></OauthLoginForm>
    </Container>
  );
}
